import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { X, Loader2, Factory } from "lucide-react";

const fmt = (n) => Number(n || 0).toLocaleString("tr-TR");
const trTarih = (s) => {
  if (!s) return "—";
  const p = String(s).slice(0, 10).split("-");
  return p.length === 3 ? `${p[2]}.${p[1]}.${p[0]}` : s;
};
// "Beklemede" terimini kolona uygun şekilde "Planda" göster
const durumLabel = (d) => (d === "Beklemede" ? "Planda" : d);
const DCLS = {
  "Tamamlandı": "bg-emerald-100 text-emerald-700 border border-emerald-200",
  "Üretimde": "bg-amber-100 text-amber-700 border border-amber-200",
  "Planda": "bg-violet-100 text-violet-700 border border-violet-200",
};

export default function PlanDetayModal({ kalip, aciklama, onClose }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/sekillendirme-plani/list")
      .then((r) => setRows((r.data || []).filter((x) => String(x.kalip_kodu || "").trim() === String(kalip || "").trim())))
      .catch(() => setRows([]));
  }, [kalip]);

  return (
    <div className="fixed inset-0 z-[60] flex items-start justify-center bg-black/50 p-4 overflow-y-auto" onMouseDown={onClose} data-testid="plan-detay-modal">
      <div className="bg-white rounded-md shadow-xl w-full max-w-3xl my-8" onMouseDown={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between border-b border-zinc-200 px-5 py-3">
          <div className="flex items-center gap-2">
            <Factory size={18} className="text-amber-600" />
            <div>
              <h3 className="font-head font-bold text-base">Şekillendirme Planı Detayı</h3>
              <p className="text-xs text-zinc-500 mono">{kalip}{aciklama ? ` — ${aciklama}` : ""}</p>
            </div>
          </div>
          <button onClick={onClose} className="text-zinc-400 hover:text-zinc-900" data-testid="plan-detay-kapat"><X size={18} /></button>
        </div>
        <div className="p-5">
          {rows === null ? (
            <div className="py-10 text-center text-zinc-400"><Loader2 className="animate-spin inline" size={18} /> Yükleniyor...</div>
          ) : rows.length === 0 ? (
            <div className="py-10 text-center text-zinc-400">Bu kalıba ait plan kaydı bulunamadı.</div>
          ) : (
            <div className="overflow-x-auto border border-zinc-200 rounded-md">
              <table className="w-full data-table text-sm">
                <thead>
                  <tr>
                    <th>Makina</th>
                    <th>Bağlanma Tarihi</th>
                    <th className="text-right">Şekillenecek</th>
                    <th className="text-right">Şekillenen</th>
                    <th className="text-right">Net</th>
                    <th className="text-right">Kalan Şek.</th>
                    <th className="text-center">Durum</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r, i) => {
                    const d = durumLabel(r.durum);
                    const kalan = Number(r.kalan_sekillendirme) || 0;
                    return (
                      <tr key={i} className={i % 2 ? "bg-zinc-50/60" : "bg-white"} data-testid={`plan-detay-satir-${i}`}>
                        <td className="text-zinc-700">{r.makina || "—"}</td>
                        <td className="mono">{trTarih(r.kalip_degisim_tarihi)}</td>
                        <td className="text-right num text-indigo-700 font-semibold">{fmt(r.sekillenecek_adet)}</td>
                        <td className="text-right num text-amber-700">{fmt(r.sekillenen_sonra)}</td>
                        <td className="text-right num text-green-700">{fmt(r.net_sonra)}</td>
                        <td className={`text-right num font-bold ${kalan > 0 ? "text-red-600" : "text-green-700"}`}>{fmt(kalan)}</td>
                        <td className="text-center">
                          <span className={`inline-block rounded-full px-2 py-0.5 text-[11px] font-bold ${DCLS[d] || "bg-zinc-200 text-zinc-600"}`}>{d}</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
